window.firstImagesAnimation = function firstImagesAnimation() {
  const firstImagesEl = document.querySelector('.first-sec__title-images');

  /*console.log(firstImagesEl);*/

  if (firstImagesEl) {
    const imagesArr = firstImagesEl.querySelectorAll('.first-sec__title-image');

    imagesArr.forEach((image, i) => {});

    firstImagesEl.classList.add('is-first-images-animation');
  }
};
